// DynamicFormSection.jsx
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./DynamicFormSection.css"; // Ensure alignment with universal styles
import SearchableDropdown from "./SearchableDropdown";

const DynamicFormSection = ({
  section,
  formData,
  resolvedFields,
  onInputChange,
  onBack,
  onNext,
  isLastSection,
  currentSectionIndex,
  warningLabels, // Now an object
}) => {
  const [defaultMatch, setDefaultMatch] = useState();

  useEffect(() => {
    let defs = {};
    section.fields.forEach((field) => {
      console.log(field.name);
      defs = { ...defs, [field.name]: field.default };
    });
    setDefaultMatch(defs);
  }, [currentSectionIndex]);

  return (
    <div className="form-section">
      <div className="form-section-content">
        <h3 className="form-section-heading">{section?.title}</h3>
        <hr className="form-section-divider" />
        <form className="add-user-form">
          {section.fields.map((field) => {
            let defaultValue = null;
            if (defaultMatch) defaultValue = defaultMatch[field.name] || null;

            console.log(defaultMatch);
            let matchedStyle = { display: "none" };
            let unmatchedStyle = { display: "none" };
            if (defaultValue) {
              console.log(defaultValue);
              if (defaultValue === formData[field.name]) {
                matchedStyle = { display: "block" };
              } else {
                unmatchedStyle = { display: "block" };
              }
              // formData[field.name] = defaultValue;
            }

            let date;
            if (field.type === "date") {
              date = new Date(formData[field.name]);
              date.setHours(1);
              // const day = date.getDate();
              // date.setDate(day + 1);
              date = date.toLocaleDateString("en-ZA");
              date = date.replace(/T\d{2}:\d{2}:\d{2}\.\d{3}Z/, "");
              date = date.replaceAll("/", "-");
            }
            return (
              <div className="form-group" key={field.name}>
                {/* Display Warnings Above the Specific Field */}
                {warningLabels[field.name] &&
                  warningLabels[field.name].length > 0 && (
                    <div className="warning-messages">
                      {warningLabels[field.name].map((warning, index) => (
                        <div key={index} className="warning-label">
                          {warning}
                        </div>
                      ))}
                    </div>
                  )}

                <label htmlFor={field.name} className="form-label">
                  {field.label}:
                </label>
                {resolvedFields.includes(field.name) ? (
                  field.type === "dropdown" ? (
                    <SearchableDropdown
                      options={field.options}
                      def={field.default}
                      name={field.name}
                      label={field.label}
                      required={field.required}
                      onInputChange={onInputChange}
                    />
                  ) : field.type === "date" ? (
                    <input
                      type="date"
                      name={field.name}
                      value={date}
                      onChange={onInputChange}
                      className="form-input"
                      required={field.required}
                    ></input>
                  ) : (
                    <input
                      type={field.type}
                      name={field.name}
                      value={defaultValue || formData[field.name]}
                      onChange={onInputChange}
                      className="form-input"
                      required={field.required}
                    />
                  )
                ) : field.type === "dropdown" ? (
                  <select
                    name={field.name}
                    value={field.default}
                    onChange={onInputChange}
                    className="form-select"
                    required={field.required}
                  >
                    <option value="">Select {field.label}</option>
                    {field.options.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type={field.type}
                    name={field.name}
                    value={formData[field.name] || ""}
                    onChange={onInputChange}
                    className="form-input"
                    required={field.required}
                  />
                )}
                <p style={matchedStyle}>✅</p>
                <p style={unmatchedStyle}>❌</p>
              </div>
            );
          })}
        </form>
      </div>
      <div className="dynamic-form-navigation">
        {!(currentSectionIndex === 1) && ( // Assuming index 1 is the first input screen after audit step 9
          <button type="button" onClick={onBack} className="action-button">
            Back
          </button>
        )}
        <button type="button" onClick={onNext} className="action-button">
          {isLastSection ? "Submit" : "Next"}
        </button>
      </div>
    </div>
  );
};

DynamicFormSection.propTypes = {
  section: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  resolvedFields: PropTypes.arrayOf(PropTypes.string).isRequired,
  onInputChange: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  isLastSection: PropTypes.bool.isRequired,
  currentSectionIndex: PropTypes.number.isRequired,
  warningLabels: PropTypes.object, // Changed to object
};

DynamicFormSection.defaultProps = {
  warningLabels: {},
};

export default DynamicFormSection;
